// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2aVnr","content":"Consent_content__1W0X9","footer":"Consent_footer__mzryW"};